
<div>
    <div class="sensor-title primary--text">
        {{ label }}
    </div>

    <div class="lm-border pa-2" style="height: 250px;">
        <div class="sensor-eid">
            {{ sensor && sensor.eid ? sensor.eid : "---" }}
        </div>

        <c-inspection-image
            v-if="sensor.image"
            style="width: 200px; height: 200px; margin-left: auto; margin-right: auto; margin-bottom: 8px;"
            :inspection-id = "inspection.id"
            :image-id      = "sensor.image"
        />
    </div>
</div>
